"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var colors_1 = require("./colors");

var themes_1 = require("./themes");

var getThemePadding = function getThemePadding(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  var paddingTop = (_c = (_b = (_a = theme) === null || _a === void 0 ? void 0 : _a.section) === null || _b === void 0 ? void 0 : _b.paddingTop, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.section.paddingTop);
  var paddingHorizontal = (_f = (_e = (_d = theme) === null || _d === void 0 ? void 0 : _d.section) === null || _e === void 0 ? void 0 : _e.paddingHorizontal, _f !== null && _f !== void 0 ? _f : themes_1.defaultTheme.section.paddingHorizontal);
  var paddingBottom = (_j = (_h = (_g = theme) === null || _g === void 0 ? void 0 : _g.section) === null || _h === void 0 ? void 0 : _h.paddingBottom, _j !== null && _j !== void 0 ? _j : themes_1.defaultTheme.section.paddingBottom);
  return paddingTop + "px " + paddingHorizontal + "px " + paddingBottom + "px";
};

var getPadding = function getPadding(props) {
  var _a;

  if (typeof props.padding === 'string') return ((_a = props.padding) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true' && props.theme ? getThemePadding(props.theme) : props.padding;
  if (typeof props.padding === 'number') return props.padding + "px";
  return props.padding && props.theme ? getThemePadding(props.theme) : 0;
};

exports.Section = styled_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  color: ", ";\n  background-color: ", ";\n  background-image: ", ";\n  min-height: ", ";\n  background-position: ", ";\n  background-size: ", ";\n  background-repeat: ", ";\n  position: relative;\n  padding: ", ";\n  max-width: 100%;\n  width: 100%;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  &:after {\n    content: '';\n    display: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ", ";\n    opacity: 0.5;\n  }\n"], ["\n  flex: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  color: ", ";\n  background-color: ", ";\n  background-image: ", ";\n  min-height: ", ";\n  background-position: ", ";\n  background-size: ", ";\n  background-repeat: ", ";\n  position: relative;\n  padding: ", ";\n  max-width: 100%;\n  width: 100%;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  &:after {\n    content: '';\n    display: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ", ";\n    opacity: 0.5;\n  }\n"])), function (_a) {
  var flex = _a.flex;
  return !flex ? '0 0 auto' : typeof flex === 'boolean' ? 1 : flex;
}, function (_a) {
  var display = _a.display;
  return display || 'flex';
}, function (_a) {
  var direction = _a.direction;
  return direction || 'column';
}, function (_a) {
  var align = _a.align,
      alignItems = _a.alignItems;
  return alignItems || align || 'unset';
}, function (_a) {
  var justify = _a.justify;
  return justify || 'unset';
}, function (props) {
  return colors_1.getColor(props, true);
}, function (props) {
  return colors_1.getBackgroundColorWithoutDefault(props);
}, function (_a) {
  var backgroundImage = _a.backgroundImage;
  return backgroundImage ? "url('" + (backgroundImage.indexOf('http:') === 0 || backgroundImage.indexOf('https:') === 0 || backgroundImage.indexOf('data:') === 0 ? backgroundImage : "https://media.nimles.com/file" + (backgroundImage.indexOf('/') === 0 ? backgroundImage : '/' + backgroundImage) + "?width=1920") + "')" : 'unset';
}, function (_a) {
  var minHeight = _a.minHeight,
      theme = _a.theme;

  var _b, _c;

  return _c = minHeight !== null && minHeight !== void 0 ? minHeight : (_b = theme.section) === null || _b === void 0 ? void 0 : _b.minHeight, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.section.minHeight;
}, function (_a) {
  var backgroundPosition = _a.backgroundPosition;
  return backgroundPosition || '50% 50%';
}, function (_a) {
  var backgroundSize = _a.backgroundSize;
  return backgroundSize || 'cover';
}, function (_a) {
  var backgroundRepeat = _a.backgroundRepeat;
  return backgroundRepeat || 'no-repeat';
}, getPadding, function (_a) {
  var display = _a.display,
      gridTemplateColumns = _a.gridTemplateColumns;
  return display && display.indexOf('grid') >= 0 && gridTemplateColumns || 'unset';
}, function (_a) {
  var display = _a.display,
      gridTemplateRows = _a.gridTemplateRows;
  return display && display.indexOf('grid') >= 0 && gridTemplateRows || 'unset';
}, function (_a) {
  var display = _a.display,
      gridColumnGap = _a.gridColumnGap;
  return display && display.indexOf('grid') >= 0 ? gridColumnGap || '30px' : 'unset';
}, function (_a) {
  var display = _a.display,
      gridRowGap = _a.gridRowGap;
  return display && display.indexOf('grid') >= 0 ? gridRowGap || '30px' : 'unset';
}, function (_a) {
  var disabled = _a.disabled;
  return disabled ? 'block' : 'none';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.background) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.background.color;
});
var templateObject_1;